import Vue from "vue";

import moment from "moment";
import vue_moment from "vue-moment";

require("moment/locale/ca");
Vue.use(vue_moment, { moment });

export default new Vue({});
